const dateRangeList = [
  { name: 'Today', code: 'Today' },
  { name: 'Yesterday', code: 'Yesterday' },
  { name: 'This month', code: 'This month' },
  { name: 'This week', code: 'This week' },
  { name: 'Last month', code: 'Last month' },
  { name: 'Last week', code: 'Last week' },
  { name: 'Last 30 days', code: 'Last 30 days' },
  { name: 'Last 7 days', code: 'Last 7 days' },
  { name: 'Custom', code: 'custom' }
]

export default dateRangeList
